module.exports = __webpack_public_path__ + "img/19-r.4f35e4ce.png";